import useSocket from "@hooks/useSocket";
import { createContext, useState } from "react";

const AppContext = createContext();
const { Provider } = AppContext;

const AppConfigProvider = ({ children }) => {
  /** */

  // App UI Locale
  const [locale, setLocale] = useState(localStorage.getItem("locale") ?? "en");

  // Update App UI Locale
  const changeLocale = (code) => {
    localStorage.setItem("locale", code);
    setLocale(code);
    return;
  };

  // Initiate SocketIO
  useSocket();

  return (
    <Provider
      value={{
        locale,
        changeLocale,
      }}
    >
      {children}
    </Provider>
  );
};
export { AppConfigProvider, AppContext };
